/* Shared mounting/disposal for opt-in storefront modules. No automatic DOM boot. */
(function () {
  'use strict';
  var storefront = window.BSStorefront = window.BSStorefront || {};
  if (storefront.lifecycle) return;

  var definitions = new Map();
  var started = false;

  function report(name, phase, error) {
    console.error('Storefront module ' + name + ' failed to ' + phase + ':', error);
  }

  function includes(scope, root) {
    return scope === document || scope === root || scope.contains(root);
  }

  function mount(name, definition, scope) {
    var roots = Array.from(scope.querySelectorAll(definition.selector));
    if (scope.matches && scope.matches(definition.selector)) roots.unshift(scope);
    roots.forEach(function (root) {
      if (definition.instances.has(root)) return;
      try {
        var dispose = definition.mount(root);
        definition.instances.set(root, typeof dispose === 'function' ? dispose : function () {});
      } catch (error) {
        report(name, 'initialize', error);
      }
    });
  }

  function unmount(name, definition, scope) {
    definition.instances.forEach(function (dispose, root) {
      if (!includes(scope, root)) return;
      definition.instances.delete(root);
      try { dispose(); } catch (error) { report(name, 'dispose', error); }
    });
  }

  function init(scope) {
    scope = scope || document;
    definitions.forEach(function (definition, name) { mount(name, definition, scope); });
  }

  function dispose(scope) {
    scope = scope || document;
    definitions.forEach(function (definition, name) { unmount(name, definition, scope); });
  }

  function onLoad(event) { init(event.target); }
  function onUnload(event) { dispose(event.target); }

  storefront.lifecycle = {
    register: function (name, selector, mountModule) {
      if (definitions.has(name)) throw new Error('Storefront module already registered: ' + name);
      var definition = { selector: selector, mount: mountModule, instances: new Map() };
      definitions.set(name, definition);
      if (started) mount(name, definition, document);
      return function unregister() {
        // A saved unregister callback must not remove a newer registration.
        if (definitions.get(name) !== definition) return;
        unmount(name, definition, document);
        definitions.delete(name);
      };
    },
    init: init,
    dispose: dispose,
    start: function () {
      if (!started) {
        document.addEventListener('shopify:section:load', onLoad);
        document.addEventListener('shopify:section:unload', onUnload);
        started = true;
      }
      init(document);
    },
    stop: function () {
      document.removeEventListener('shopify:section:load', onLoad);
      document.removeEventListener('shopify:section:unload', onUnload);
      started = false;
      dispose(document);
    }
  };
})();
